import React, { useEffect } from 'react';

/**
 * メモを書く画面。
 *
 * 画面が狭いと行の中に入力欄を置けないので、別画面にしている。
 * 予定・実行中・完了・追加バーのどれからでも開く。
 */
function NoteModal({ title, name, meta, value, canEdit, onChange, onClose }) {
  useEffect(() => {
    const onKey = (e) => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal note-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-head">
          <h2>{title || 'メモ'}</h2>
          <button className="modal-close" onClick={onClose} title="閉じる">
            ×
          </button>
        </div>

        <div className="modal-body">
          {name !== undefined && <div className="note-task-name">{name || '(無題)'}</div>}

          {meta && meta.length > 0 && (
            <div className="note-log">
              {meta.map((m) => (
                <span key={m}>{m}</span>
              ))}
            </div>
          )}

          {canEdit ? (
            <textarea
              className="note-input"
              value={value || ''}
              placeholder="メモ"
              rows={5}
              autoFocus
              onChange={(e) => onChange(e.target.value)}
            />
          ) : (
            <div className="note-static">{value || 'メモはありません'}</div>
          )}
        </div>
      </div>
    </div>
  );
}

export default NoteModal;
